import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

const COLUMN_WIDTH = 268;

/// `focused`: destaque de uns segundos, quando o painel abre o quadro nesta coluna.
export const columnSx = (cc: CrmColors, focused: boolean): SxProps<Theme> => ({
    minWidth: COLUMN_WIDTH,
    maxWidth: COLUMN_WIDTH,
    width: COLUMN_WIDTH,
    flexShrink: 0,
    bgcolor: cc.columnBg,
    borderRadius: '12px',
    border: `1px solid ${focused ? cc.accent : cc.border}`,
    boxShadow: focused ? `0 0 0 2px ${cc.accent}` : 'none',
    transition: 'box-shadow .3s, border-color .3s',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'var(--crm-column-max-height, calc(100dvh - 330px))',
});

/// O cabeçalho é a alça de arrasto da coluna.
export const HEADER_SX: SxProps<Theme> = { p: 1.5, pb: 0, cursor: 'grab', '&:active': { cursor: 'grabbing' } };

export const columnTotalSx = (cc: CrmColors): SxProps<Theme> => ({
    color: cc.textMuted,
    fontSize: '10.5px',
    fontWeight: 600,
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1.2,
});

export const leadCountSx = (cc: CrmColors): SxProps<Theme> => ({
    mr: 0.5,
    px: 0.75,
    py: 0.1,
    borderRadius: 1,
    border: `1px solid ${cc.border}`,
    color: cc.textSecondary,
    fontWeight: 600,
});

export const LEADS_AREA_SX: SxProps<Theme> = {
    flex: 1,
    overflowY: 'auto',
    p: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    minHeight: 0,
};

export const addLeadButtonSx = (cc: CrmColors, darkMode: boolean): SxProps<Theme> => ({
    color: cc.textSecondary,
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontSize: 12,
    py: 1,
    border: `1px dashed ${cc.dividerStrong}`,
    borderRadius: '9px',
    '&:hover': {
        color: cc.textPrimary,
        bgcolor: darkMode ? 'rgba(255,255,255,.05)' : 'rgba(0,0,0,.04)',
        borderColor: cc.borderHover,
    },
});

/// Marca onde o card entra; sem lado, ocupa o lugar na coluna vazia; com lado, fica sobre a borda do card.
export const dropLineSx = (color: string, side?: 'top' | 'bottom'): SxProps<Theme> => ({
    position: side ? 'absolute' : 'relative',
    left: 0,
    right: 0,
    ...(side === 'top' && { top: -5 }),
    ...(side === 'bottom' && { bottom: -5 }),
    height: 3,
    borderRadius: '2px',
    bgcolor: color,
    zIndex: 2,
});
